/**
 * Get Twitter Username from Twitter URL
 * @source https://www.regexplanet.com/advanced/javascript/index.html
 */
const getTwitterUsername = (twitter_url: string) => {
  const getTwitterUsername = new RegExp(
    '((https?://)?(www.)?twitter.com/)?(@|#!/)?([A-Za-z0-9_]{1,15})(/([-a-z]{1,20}))?'
  );
  return getTwitterUsername.exec(twitter_url)[5];
};

export default getTwitterUsername;
